import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import axios from 'axios';
import $ from 'jquery';
const ViewGallery = (props) => {

    const [items, setitems] = useState([]);
    const url = process.env.REACT_APP_APIURL + "booking/getimages?companyid="+props.companyid;
    useEffect(() => {
         setTimeout( () => {
             $('#example3').DataTable().destroy()
        populatedata()
        
        },100)

    }, []);
    useEffect(() => {
        $('#example3').DataTable();
      
    }, [items]);
    async function populatedata() {
        await fetch(url).then(res => res.json()).then(result =>
            
            setitems(result)
        );
    }
     async function deletedata(id,index) {
         const urldelete = process.env.REACT_APP_APIURL + 'booking/DeleteGallery?gal_id='+id;
         let res = await axios.post(urldelete);
         if (res.status == 200) {
             swal({
                 title: "Deleted Successfully",
                 icon: "success"
             })
             const items1 = items.filter(item => item.gal_id !== id);
             setitems(items1);
           /*  await populatedata();*/

         }
    }


    function handleDelete(id,index) {
        swal({
            title: "Are you sure?",
            //  text: "Once deleted, you will not be able to recover this imaginary file!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete)
            {
                deletedata(id,index);
              
            } else {
                swal("0 Rows deleted");
            }
        });
    }

  
    return (
        <div className="row">
            
            <div className="col-12">
                <div className="card">
                    <div className="card-header">
                        <h3 className="me-auto mb-0">View Gallery</h3>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table id="example3" className="display" data-page-length='50'>
                                <thead>
                                    <tr>
                                        <th>Unit Name</th>
                                        <th>Image</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map((item,index) =>
                                        <tr key={item.gal_id}>
                                            <td>{item.unit_name}</td>
                                            <td><img src={'data:image/png;base64,' + item.image} height="80" width="150" /></td>
                                            <td>
                                                <span className="d-flex">
                                                    <button href="#" className="btn btn-danger shadow btn-xs sharp"
                                                        onClick={(id) => handleDelete(item.gal_id, index)}>
                                                        <i className="fa fa-trash"></i>
                                                    </button>
                                                </span>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewGallery